import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { push, goBack } from 'connected-react-router';
import { useTranslation } from 'react-i18next';
import { Layout, Card, Spin, Button } from 'antd';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import AppleSignin from 'react-apple-signin-auth';
import { useGoogleLogin } from '@react-oauth/google';

// COMPONENTS
import LoginForm from '../../Components/Forms/LoginForm';
import LoginHeader from '../../Components/LoginHeader';
import ButtonComponent from "../../Components/Button";
import Images from '../../Images';

// REDUCER
import AuthActions from './reducer';

function LoginPage(props) {
  const { auth, error, fetching, rememberMe } = props;

  const history = useHistory();
  const { t } = useTranslation();

  function handleSubmit(data) {
    props.signIn(data.email, data.password);
  }

  const responseFacebook = (response) => {
    console.log('fb response', response);
    if (response && response.accessToken) {
      props.socialAuth(response.accessToken, 'facebook');
    }
  };

  const responseGoogle = useGoogleLogin({
    onSuccess: (response) => {
      console.log('google onSuccess response', response);
      if (response && response?.access_token) {
        props.socialAuth(response?.access_token, 'google');
      }
    },
    onFailure: (response) => {
      console.log('google onFailure response', response);
      if (response && response?.access_token) {
        props.socialAuth(response?.access_token, 'google');
      }
    }
  });

  const responseApple = (response) => {
    console.log('apple response', response);
    if (response && response.authorization) {
      if(response?.user){
        props.socialAuth(response.authorization.id_token, 'apple', response?.user);
      }else{
        props.socialAuth(response.authorization.id_token, 'apple');
      }
    }
  };

  useEffect(() => {
    if (auth.userInfo && !auth.isAdmin) {
      history.push('/dashboard');
    } else if (auth.userInfo && auth.isAdmin) {
      history.push('/admin/customers');
    }else{
      document.title = 'Login - In_Home';
    }
    if(error) props.resetError()
  }, []);

  const handleClearError =()=>{
    if(error) props.resetError()
  }

  return (
    <Layout>
      <Spin size="large" spinning={fetching} wrapperClassName='full-screen'>
        <div className="login-row">
          <LoginHeader />
          {(error && typeof error === 'string') && (
            <div className={'force-logout-error'}>
              {error}
            </div>
          )}
          <div className="login-content">
            <div className="content-main">
              <div className="content-left">
                <Card className="login-card">
                  <h2 className="card-title" style={{ marginBottom: 0 }}>
                    {t('Sign In')}
                  </h2>
                  <LoginForm
                    rememberMe={rememberMe}
                    setRemember={props.setRemember}
                    onSubmit={handleSubmit}
                    error={error?.message}
                  >
                    <div className="social-title">
                      <span>{t('Sign In With')}</span>
                      <div className="middle-line" />
                    </div>
                    <div className="social-btn-block">
                      <ButtonComponent
                        className="btn-primary"
                        type="primary white"
                        onClick={responseGoogle}
                      >
                        <img
                          className="btn-icon icon-space"
                          src={Images.google}
                          alt=""
                        />
                        Google
                      </ButtonComponent>
                      <FacebookLogin
                        appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                        scope="public_profile,email"
                        returnScopes={true}
                        textButton
                        cssClass="my-social-btn"
                        callback={responseFacebook}
                        disableMobileRedirect={true}
                        render={(renderProps) => (
                          <Button
                            className="btn-primary"
                            type="primary white"
                            onClick={renderProps.onClick}
                          >
                            <img
                              className="btn-icon icon-space"
                              src={Images.facebook}
                              alt=""
                            />
                            Facebook
                          </Button>
                        )}
                      />

                      <AppleSignin
                        authOptions={{
                          clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
                          scope: 'email name',
                          redirectURI: process.env.REACT_APP_BASE_URI + '/login',
                          state: 'state',
                          nonce: 'nonce',
                          usePopup: true,
                        }}
                        className="apple-auth-btn"
                        noDefaultStyle={false}
                        onSuccess={responseApple}
                        onError={responseApple}
                        skipScript={false}
                        render={(renderProps) => (
                          <Button
                            className="btn-primary"
                            type="primary white"
                            onClick={renderProps.onClick}
                          >
                            <img
                              className="btn-icon icon-space"
                              src={Images.apple}
                              alt=""
                            />
                            Apple
                          </Button>
                        )}
                      />
                    </div>

                    <div className="sign-up-link sign-up-link_12">
                      {t('New to In_Home?')}{' '}
                      <Link to="/sign-up" onClick={handleClearError}>{t('Get Started')}</Link>
                    </div>
                  </LoginForm>
                </Card>
              </div>
              <div className="content-right">
                <div
                  className="bg"
                  /*style={{
                    backgroundImage: `url(${
                      isMobile ? Images.signInMobile : Images.signIn
                    })`,
                  }}*/
                />
              </div>
            </div>
          </div>
        </div>
      </Spin>
    </Layout>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  error: state.auth.error,
  fetching: state.auth.fetching,
  rememberMe: state.auth.rememberMe,
  isMobile: state.nav.isMobile,
});

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  navPush: (path, state) => dispatch(push(path, state)),
  navGoBack: () => dispatch(goBack()),
  signIn: (email, password) =>
    dispatch(AuthActions.signInRequest(email, password)),
  resetError: () => dispatch(AuthActions.authErrorReset()),
  setRemember: (data) => dispatch(AuthActions.setRemember(data)),
  socialAuth: (accessToken, type, user) =>
    dispatch(AuthActions.socialAuthRequest(accessToken, type, user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
